var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLampChargeRed2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 16.4375L22.771 20.3125C22.271 21.1667 22.6876 21.875 23.6668 21.875H26.3126C27.3126 21.875 27.7085 22.5833 27.2085 23.4375L25.0001 27.3125",
    stroke: "#CB1C68",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2917 37.5834V35.1667C12.5 32.2709 8.5625 26.625 8.5625 20.625C8.5625 10.3125 18.0417 2.22921 28.75 4.56254C33.4583 5.60421 37.5833 8.72921 39.7292 13.0417C44.0833 21.7917 39.5 31.0834 32.7708 35.1459V37.5625C32.7708 38.1667 33 39.5625 30.7708 39.5625H19.2917C17 39.5834 17.2917 38.6875 17.2917 37.5834Z",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.707 45.834C22.4779 44.4798 27.5195 44.4798 32.2904 45.834",
    stroke: "#CB1C68",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampChargeRed2);
export default __webpack_public_path__ + "static/media/lamp_charge_red_2.ea311f26328b37768be1de36544b51b8.svg";
export { ForwardRef as ReactComponent };